<div
  class="content-style-class"
  [style.filter]="showLoader === true ? 'blur(0.2rem)' : 'blur(0)'"
>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ dataService.res("notification") }}</h2>
    </div>
  </div>
  <div class="content-block">
    <div
      fxLayout="row"
      fxLayout.xs="column"
      fxLayout.sm="column"
      fxFlexFill
      [fxLayoutGap]="showEditTask ? '25' : '0'"
      fxLayoutGap.xs="15"
      fxLayoutGap.sm="15"
    >
      <div
        [fxFlex]="showEditTask ? '65%' : '100%'"
        fxFlex.xs="100"
        fxFlex.sm="100"
        fxLayout="row"
        fxLayout.xs="column"
        fxLayout.sm="column"
      >
        <div
          class="dx-card responsive-paddings card-radius"
          style="width: 100%"
        >
          <abc-grid
            #notificationGrid
            class="grid-group-by-Style chech-box-Column custome-export-style abc-grid-custom-style grid-adaptive-mode"
            style="margin-bottom: 10px"
            [height]="'95%'"
            [width]="'100%'"
            [showBorders]="true"
            [noDataText]="
              dataService.res(
                'weAreSorry,ButWeCouldNotFindAnyResultsForYourSearch'
              )
            "
            [setupDefaultLayoutOnInitialization]="true"
            [columnHidingEnabled]="true"
            [showRowLines]="true"
            [showColumnLines]="true"
            [columns]="notificationGridColumns"
            [dataSource]="filteredNotifications"
            (onCellClick)="onCellClick($event)"
            (onRowClick)="viewNotificationDetails($event)"
            (onSelectionChanged)="onSelectionChanged($event)"
            (onEditorPreparing)="onEditorPreparing($event)"
          >
            @if (selectedFilterId !== NotificationFilterType.Read) {
              <dxo-selection
                mode="multiple"
                showCheckBoxesMode="always"
              ></dxo-selection>
            }
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true">
            </dxo-search-panel>
            <dxo-toolbar>
              <dxi-item location="after">
                <abc-select-box
                  displayExpr="name"
                  valueExpr="value"
                  [items]="notificationFilterOptions"
                  (onValueChanged)="onNotificationFilterChange()"
                  [(value)]="selectedFilterId"
                >
                </abc-select-box>
              </dxi-item>
              <dxi-item name="columnChooserButton" location="after"></dxi-item>
              <dxi-item name="searchPanel" location="after"></dxi-item>
            </dxo-toolbar>
          </abc-grid>

          @if (selectedFilterId !== NotificationFilterType.Read) {
            <abc-button
              class="btn-Pfilchten-overview"
              [stylingMode]="'text'"
              [text]="dataService.res('notification-markSelectionAsRead')"
              [disabled]="selectedKeys.length === 0"
              (onClick)="markSelectedNotificationsAsRead()"
            >
            </abc-button>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="end end"></div>
      </div>
      <div
        #detailsContainer
        [fxFlex]="showEditTask ? '33%' : '0'"
        [fxFlex.xs]="showEditTask ? '100' : '0'"
        [fxFlex.sm]="showEditTask ? '100' : '0'"
        fxLayout="column"
        [ngClass]="{
          editTaskShown: showEditTask,
          editTaskHidden: !showEditTask,
        }"
        [style.width.xs]="showEditTask ? '100%' : '0'"
        [style.width.sm]="showEditTask ? '100%' : '0'"
      >
        @if (showEditTask) {
          <notification-details
            #notificationDetails
            class="dx-card responsive-paddings card-radius"
            [notificationItem]="notificationItem"
            (hidePopupEvent)="onHidePopUp($event)"
            (updateNotification)="handleUpdateNotification($event)"
          >
          </notification-details>
        }
      </div>
    </div>
  </div>
</div>

<confirmation-popup
  #readNotificationPopup
  [title]="dataService.res('confirm')"
  [message]="
    selectedKeys.length > 1
      ? formatMessage(
          'notification-areYouSureYouWantToMarkNotification(s)AsRead?',
          selectedKeys.length.toString()
        )
      : dataService.res(
          'notification-areYouSureYouWantToMarkThisNotificationAsRead?'
        )
  "
  [primaryBtnText]="dataService.res('yes')"
  [secondaryBtnText]="dataService.res('no')"
>
</confirmation-popup>
